/**
 * @param {string} [url]
 * @param {boolean} [absolute]
 * @param {boolean} [withQuery]
 * @param {boolean} [withFragment]
 *
 * @return string
 */
let getUrl = (url, absolute, withQuery, withFragment) => {
  url = url || document.location.href;

  if (!absolute)
    url = url.replace(/^https?:\/\/.*?\//, '/');
  else if (!url.match(/^https?:/))
    url = document.location.origin.concat(url);

  if (!withFragment)
    url = url.replace(/#.*/, '');

  if (!withQuery)
    url = url.replace(/\?.*?(#|$)/, '$1');

  return url;
};

/**
 * Check WebP support
 *
 * @return Promise
 */
let isWebpSupport = () => {
  let deferred = jQuery.Deferred(),
      image = new Image();

  image.onload = () => { deferred.resolve(); };
  image.onerror = () => { deferred.reject(); };
  image.src = 'data:image/webp;base64,UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA=='; // 1x1 px like sp.gif

  return deferred.promise();
};

//-----------------------------------------------------------------------------
// Some strings extensions
//-----------------------------------------------------------------------------
/**
 * Encodes special characters into HTML entities
 */
String.prototype.escapeHtml = function() {
  const map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&#039;'
  };

  return this.replace(/[&<>"']/gi, m => map[m]);
};

/**
 * Strip HTML and PHP tags from a string
 */
String.prototype.stripTags = function() {
  return this.replace(/<\/?[^>]+>/gi, '');
};
//-----------------------------------------------------------------------------